import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FormPackType } from '@upstart/harmony/lib/constants';

import formPacksActions from '../../redux/formPacks/actions';
import FormPackList from '../../components/FormPackList';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import ContentPage from '../ContentPage';
import './FormPacks.scss';

class FormPacks extends Component {
  componentDidMount() {
    const { match } = this.props;
    const { dealerId } = match.params;
    this.props.actions.formPacksRequest(dealerId);
  }

  render() {
    const { formPacks, dealer, actions } = this.props;
    const formPackList = formPacks.formPacks.filter(
      formPack => formPack.type === FormPackType.INSTORE,
    );
    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="form-packs-table">
          <DealerNav />
          <FormPackList
            dealer={dealer}
            list={formPackList}
            error={formPacks.error}
            fetching={formPacks.fetching}
            onDelete={actions.deleteFormPackRequest}
            history={this.props.history}
          />
        </div>
      </SidebarContainer>
    );
  }
}

FormPacks.propTypes = {
  match: PropTypes.object,
  formPacks: PropTypes.object,
  history: PropTypes.object,
  dealer: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ formPacks }) => ({
  formPacks,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...formPacksActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(FormPacks));
